<app-collapsible-container
    [id]="id"
    [title]="title"
    [icon]="icon ? icon : isStudentIcon ? 'i-graduation-cap' : 'i-users'"
    [maxSelection]="isAutoGenerated ? 0 : maxLength"
    [currentSelected]="selectedUsersList.length"
    (elementSizeModification)="elementSizeModification.emit()"
>
    <div class="vertical">
        <div *ngIf="showList">
            <div class="search-field">
                <input
                    (input)="search($event)"
                    placeholder="{{ 'REPERTOIRE.FORMS.USERS.PLACEHOLDERS.SEARCH-FIELD' | translate }}"
                    [value]="searchTerms"
                    type="text"
                />
            </div>

            <div class="generic-checkbox">
                <app-generic-checkbox
                    [data]="filteredUsersLists | sortBy: 'firstname'"
                    [labelRef]="['firstname', 'lastname']"
                    [valueRef]="'id'"
                    (change)="updateSelectedUsersList()"
                    [formControl]="parentFormControl"
                >
                </app-generic-checkbox>
            </div>
        </div>

        <app-form-errors
            *ngIf="parentFormControl.touched"
            [errors]="parentFormControl.errors"
            (errorDisplay)="elementSizeModification.emit()"
            [readOnly]="false"
            [data]="maxLength"
        ></app-form-errors>

        <div *ngIf="!showList && selectedUsersList.length < 1" class="disclaimer big">
            {{ textPlaceholder | translate }}
        </div>

        <div *ngIf="!showList && selectedUsersList.length > 0 && usersLightLists">
            <ul>
                <ng-container *ngFor="let user of selectedUsersList | sortBy: 'firstname'">
                    <li class="user-card">
                        <div class="selected-user">
                            {{ user?.firstname }} {{ user?.lastname }}
                            <div>
                                <a
                                    class="icon fav-teacher"
                                    *ngIf="titularControl"
                                    [ngClass]="{
                                        'i-star-full -selected': titularControl.value.includes(user.id),
                                        'i-star-empty': !titularControl.value.includes(user.id)
                                    }"
                                    (click)="setTitular(user.id)"
                                ></a>
                                <a class="icon i-close" *ngIf="!readonly" (click)="updateLists(user)"></a>
                            </div>
                        </div>
                    </li>
                </ng-container>
            </ul>
        </div>

        <app-form-errors
            *ngIf="titularControl && titularControl.touched"
            [errors]="titularControl.errors"
            (errorDisplay)="elementSizeModification.emit()"
            [readOnly]="false"
            [data]="2"
        ></app-form-errors>

        <app-generic-button
            *ngIf="!readonly"
            (buttonClick)="showUserList()"
            [classes]="'btn btn--secondary '"
            [inputText]="
                showList ? closeButtonPlaceholder : selectedUsersList.length === 0 ? addButtonPlaceholder : modifyButtonPlaceholder
            "
        >
        </app-generic-button>
    </div>
</app-collapsible-container>
